import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation EpisodeEnable($uid: String!){
        episode_enable (uid: $uid) {
            success
        }
    }
`;

export async function episodeEnable(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ episode_enable: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.episode_enable;
}
